import React, { useState, useEffect } from 'react';
import axios from 'axios';
import useWebSocket from './useWebSocket';
import { protectedAPI } from '../services/api';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import DoNotDisturbOnIcon from '@mui/icons-material/DoNotDisturbOn';
import ReactTimeAgo from 'react-time-ago';
import { useAuth } from '../context/AuthContext';

function StatusIcon({status}) {
  return (
    <>
      {status ? <CheckBoxIcon style={{ color: "green" }}></CheckBoxIcon> :
        <DoNotDisturbOnIcon style={{ color: "red" }}></DoNotDisturbOnIcon>}
    </>
  );
};

const TableComponent = () => {
    const [items, setItems] = useState([]);
    const wsData = useWebSocket(`${process.env.REACT_APP_WEBSOCKET_BASE_URL}/recognitions_created/`);
    const { user, loading } = useAuth();
    
    useEffect(() => {
        fetchItems();
    }, []);

    useEffect(() => {
        if (wsData && wsData.data.item.user === user.username) {
            if (wsData.type === 'recognition_created') {
                if (wsData.data.action === 'create') {
                    setItems(prev => [wsData.data.item, ...prev].slice(0,10));
                }
            }
            else if (wsData.type === 'recognitions_update') {
                setItems(items.map(item => {
                    if (item.id === wsData.data.id) {
                        return {
                            ...item,
                            access_granted: wsData.data.access_granted,
                        };
                    }
                    else return {...item};
                }));
            }
        }
    }, [wsData]);

    const fetchItems = async () => {
        try {
            const response = await protectedAPI.getRecognitionHistoryLast();
            setItems(response.data);
        } catch (error) {
            console.error('Error fetching items:', error);
        }
    };

    return (
        <div>
            <h2>Последние события</h2>
            <table className='modern-table'>
                <thead>
                    <tr>
                        <th>Проезд</th>
                        <th>Время</th>
                        <th>Номер</th>
                        <th>Камера</th>
                    </tr>
                </thead>
                <tbody>
                    {items.map(item => (
                        <tr key={item.id}>
                            <td><StatusIcon status={item.access_granted}></StatusIcon></td>
                            <td><ReactTimeAgo date={item.recognized_at} locale="ru"/></td>
                            <td>{item.license_plate_number_ru}</td>
                            <td>{item.address}, {item.camera}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default TableComponent;